export const UserType = {
    ASSESSOR: 'Assessor',
    CONTRACTOR: 'Contractor',
    SUPPLIER: 'Supplier'
    // TODO any other user types.
};
